import * as React from 'react';
export const naverpaySvg = React.forwardRef(function naverpaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.336 4.24v4.024L6.544 4.24H4.24v7.52h2.424V7.736l2.792 4.024h2.304V4.24H9.336ZM16 8c0 4.416-3.584 8-8 8s-8-3.584-8-8 3.584-8 8-8 8 3.584 8 8Z',
    }),
  );
});
naverpaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var naverpay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'naverpay',
  svg: naverpaySvg,
};
